<template>
    <div class="dvidsvideo-container" ref="dvidsContainer">
        <div class="video-overlay"></div>
        <div class="DvidsVideo">
            <video v-bind:id="videoId"
                   class='dvidsPlayer'
                   width='100%'
                   preload='auto'
                   controls
                   v-bind:src='videoSrc' v-bind:poster='videoImg'>
                <track kind='subtitles' v-bind:src="captionsSrc" srclang='en' />
            </video>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'dvidsvideo',
        props: {
            slideId: String,
            videoObj: Object,
            portalId: String,
        },
        computed: {
            videoId: function() {
                return `player${this.slideId}`;
            },
            videoSrc: function() {
                const width=1080;
                const video=this.videoObj.files.reduce((prev,current) => Math.abs(current.width-width)<Math.abs(prev.width-width)? current:prev);
                return video.src;
            },
            videoImg: function() {
                return this.videoObj.image;
            },
            captionsSrc: function() {
                if(this.portalId&&this.videoObj.id)
                    return `/desktopmodules/sharedlibrary/handlers/dvidscaption.ashx?PortalId=${this.portalId}&AssetId=${this.videoObj.id}&Format=srt`;

                return "/desktopmodules/sharedlibrary/handlers/dvidscaption.ashx?PortalId=";
            }
        },
        methods: {
            initializePlayer: function() {
                const selectedFileVideoId=this.videoObj.id.split(":")[1];
                const selectedFileUnitId=this.videoObj.unit_id;
                let videoSuccess=false;
                let videoPlayed=false;
                let ccEnabled=false;
                new MediaElementPlayer(this.videoId,{
                    enablePluginDebug: true,
                    pluginPath: "/DesktopModules/SharedLibrary/Plugins/MediaElement4.2.9/",
                    features: ["playpause","progress","current","duration","tracks","volume","fullscreen"],
                    pauseOtherPlayers: true,
                    stretching: 'responsive',
                    hideCaptionsButtonWhenEmpty: false,
                    success: function(me) {
                        me.addEventListener('progress',function(e) {
                            if(!videoSuccess&&ANALYTICSLIBRARY!==undefined&&typeof ANALYTICSLIBRARY.init==='function'&&typeof ANALYTICSLIBRARY.loadAnalyticsParam==='function') {
                                ANALYTICSLIBRARY.init([selectedFileVideoId,selectedFileUnitId]);
                                ANALYTICSLIBRARY.loadAnalyticsParam();
                                videoSuccess=true;
                            }
                        });

                        me.addEventListener('playing',function(e) {
                            if(!videoPlayed) {
                                DVIDSVideoAnalytics.track('play',analyticsParams);
                                //console.debug('DVIDSVideoAnalytics PLAY EVENT');
                                videoPlayed=true;
                            }
                        });

                        me.addEventListener('play',function(e) {
                            $(".video-overlay").hide();
                        });

                        me.addEventListener('pause',function(e) {
                            $(".video-overlay").show();
                        });

                        me.addEventListener('ended',function(e) {
                            DVIDSVideoAnalytics.track('ended',analyticsParams);
                            //console.debug('DVIDSVideoAnalytics ENDED EVENT');
                            videoPlayed=false;
                            $(".video-overlay").show();
                        });
                    },
                });

                // ASSIGN CAPTIONS SELECTOR TO JQUERY OBJECT, SET CLICK DELEGATE AND TURN ON CAPTIONS IF PREVIOUSLY ENABLED
                const captionsSelector=$(this.$refs.dvidsContainer).find("div.mejs__captions-selector");
                captionsSelector.delegate("input:radio","click",function() {
                    var lang=this.value;
                    if(lang=="none") {
                        ccEnabled=false;
                    }
                    else {
                        ccEnabled=true;
                    }
                    setTimeout(function() {
                        var none=captionsSelector.find("#mep_0_captions_none");
                        var en=captionsSelector.find("#mep_0_captions_en");
                        if(none.length>0) {
                            none[0].checked=!ccEnabled;
                        }
                        if(en.length>0) {
                            en[0].checked=ccEnabled;
                        }
                    },10);
                });
            }
        },
        // Life Cycle
        created: function() { },
        mounted: function() {
            this.initializePlayer();
        },
    };
</script>

<style lang="scss">
    .dvidsvideo-container {
        height: 100%;
        width: 100%;
        background: black;

        .video-overlay {
            top:50%;
            left:50%;
            position:absolute;
            pointer-events:none;
                       }
    }

    .dvidsPlayer {
        max-height: inherit !important;
    }

    .DvidsVideo {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-bottom: 0;
    }
</style>
